export enum AutoTapType {
  Play = 'play',
  Pause = 'pause',
  Stop = 'stop',
}
